<template>
  <!-- @TODO api 이슈 공유 후 작업 -->
  <div class="contain">
    <!-- 검색 조건 -->
    <div ref="search_form"></div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('CodeSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('CodeAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('CodeUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('CodeDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('CodeSearch')"
        :size="size"
        @click="expand = !expand"
        icon="el-icon-check"
        >{{ !expand ? this.$t('보기') : this.$t('접기') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('CodeAdd') || checkAuthActionAccess('CodeUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="16">
        <el-table
          :height="tableHeight"
          ref="table"
          border
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          :size="size"
          :empty-text="$t('데이타 없음')"
          @row-click="handleRowClick"
          @row-dblclick="handleRowDbClick"
          @select="handleRowChecked"
          @select-all="handleRowChecked"
          row-key="cd"
          :tree-props="{ children: 'subCode' }">
          <el-table-column
            :label="tableData.length.toString()"
            type="index"
            width="55"
            align="center"
            fixed
            label-class-name="data_cnt"></el-table-column>
          <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
          <el-table-column
            :label="$t('코드')"
            prop="cd"
            width="100"
            align="left"
            :fixed="!$device.mobile"></el-table-column>
          <el-table-column
            :label="$t('코드값')"
            prop="val"
            min-width="150"
            fixed
            show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('코드명')" prop="nm" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('순서')" prop="ord" min-width="50" align="center"></el-table-column>
          <el-table-column
            :label="$t('사용 가능 여부')"
            prop="useYn"
            min-width="110"
            align="center"
            :formatter="mainVue.formatterCode"></el-table-column>
          <el-table-column :label="$t('참조값1')" prop="ref1" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('참조값2')" prop="ref2" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('참조값3')" prop="ref3" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column
            :label="$t('코드 설명')"
            prop="codeDesc"
            min-width="300"
            show-overflow-tooltip></el-table-column>
        </el-table>
      </el-col>
      <el-col :md="8">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('코드') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-form-item :label="$t('상위 코드명')" v-if="null != inputForm.topCode" required>
                <span>{{ inputForm.topCode.nm }}</span>
              </el-form-item>
              <el-form-item :label="$t('코드값')" :error="formError.val" required>
                <el-input
                  v-model="inputForm.val"
                  maxlength="50"
                  :disabled="'U' == inputForm.statu"
                  clearable
                  show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('코드명')" :error="formError.nm" required>
                <el-input v-model="inputForm.nm" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('순서')" :error="formError.ord" required>
                <el-input-number v-model="inputForm.ord" :min="1" :max="99"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('사용 가능 여부')" required>
                <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>
              </el-form-item>
              <el-form-item :label="$t('코드 설명')">
                <el-input
                  v-model="inputForm.codeDesc"
                  type="textarea"
                  maxlength="250"
                  clearable
                  show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('참조값1')" :error="formError.ref1">
                <el-input v-model="inputForm.ref1" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('참조값2')" :error="formError.ref2">
                <el-input v-model="inputForm.ref2" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('참조값3')" :error="formError.ref3">
                <el-input v-model="inputForm.ref3" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/code'

    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.expand = false

    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    expand: function (newVal, oldVal) {
      for (var i = 0, len = this.$refs.table.tableData.length; i < len; i++) {
        if (null != this.$refs.table.tableData[i].subCode && this.$refs.table.tableData[i].subCode.length > 0) {
          this.$refs.table.toggleRowExpansion(this.$refs.table.tableData[i], newVal)
        }
      }
    },
    'inputForm.val': function (newVal, oldVal) {
      if ('' != newVal && 'I' === this.inputForm.statu) {
        this.chkVal()
      }
    },
  },
  methods: {
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        cd: 0,
        topCode: null,
        val: '',
        nm: '',
        ord: 1,
        useYn: 'Y',
        codeDesc: '',
        ref1: '',
        ref2: '',
        ref3: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        val: '',
        nm: '',
        codeDesc: '',
        ref1: '',
        ref2: '',
        ref3: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 그리드 두번 클릭 이벤트
    handleRowDbClick: function (val) {
      this.btn.upDisabled = true
      this.selectData = null
      this.$refs.table.setCurrentRow()
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].cd
      }
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.formError = this.initFormError()

      if (null != this.selectData) {
        if (null != this.selectData.topCode) {
          this.mainVue.$message({ type: 'warning', message: this.$t('상위 코드를 선택 하여 주십시오.') })
          return
        } else {
          this.inputForm.topCode = this.selectData
        }
      }

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.cd,
        function (result) {
          result.statu = 'U'

          this.inputForm = result

          this.formError = this.initFormError()

          this.btn.saveDisabled = false
          this.fromDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        null,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.btn.saveDisabled = true
          this.fromDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()

          // 접기
          this.expand = false
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      if (0 == this.checkedData.length) {
        this.mainVue.$message({ type: 'warning', message: this.$t('삭제 하실 코드 정보를 체크 하여 주십시오.') })
        return
      }

      this.mainVue
        .$confirm(this.$t('코드 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.cd,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 코드 값 체크
    chkVal: function () {
      this.mainVue.$axios.patchNonLoading(
        this.url +
          '/chk/' +
          (null == this.inputForm.topCode ? 0 : this.inputForm.topCode.cd) +
          '/' +
          this.inputForm.val,
        null,
        null,
        function (result) {
          if ('' == result) {
            this.formError.val = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.val = this.$t('이미 사용중인 코드값입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
  },
}
</script>
